const LOCALSTORAGE = {
  AUTH: 'auth',
  BUY_TRADE: 'buy-last-trade',
  ECS_PROFILE_CONTEXT: 'ecsProfileContext',
  LIST_VARIANT: 'listVariant',
  MANUFACTURERS: 'manufacturers',
  MEDIA_METADATA: 'mediaMetadata',
  OMP_SELECTED_DEALER: 'selected-dealer',
  PAYMENTS_ON_HOLD: 'payments-on-hold',
  PENDING_TRADE: 'pending-trade',
  RETAIL_TRADE: 'retail-trade',
  SEARCH_TRADE: 'search-last-trade',
  SHOULD_REDIRECT_OMP: 'should-redirect-omp',
  USERLOCALE: 'user-locale',
  STORAGE_SELECTED_VIEW: 'storage_selected_view'
};

export const LOCALSTORAGE_EXPIRY_MINUTES = {
  [LOCALSTORAGE.LIST_VARIANT]: 60
};

export const LOCALSTORAGE_METADATA_VERION = {
  ONE: 1,
  TWO: 2
};

export default LOCALSTORAGE;
